import { DOC_FLOW_COMBINING_ENTITY } from '../../../constants/entity'
import { PageLoader } from '../../Page'
import { useCombiningPhase } from '../DocFlow.hooks'
import { DocFlowCombiningTableRow } from '../DocFlowCombiningTableRow'
import { DocFlowPhaseTable } from '../DocFlowPhaseTable'

import { updateTableConfig } from './DocFlowCombining.api'
import {
  getCombiningTableItemActions,
  getFilterApi,
} from './DocFlowCombining.utils'
import { DocFlowCombiningProgress } from './DocFlowCombiningProgress'

function DocFlowCombining() {
  const {
    asyncActionInProccess,
    getCombiningMassActions,
    handleCombinedDocument,
    isPerformingMassAction,
    isPhaseLoading,
    loadingPercent,
    selectionData,
    setItemAction,
    setMassAction,
    tableData,
  } = useCombiningPhase()

  const { isRefetching } = tableData

  return (
    <>
      {!isPhaseLoading && (isRefetching || isPerformingMassAction) ? (
        <PageLoader />
      ) : null}

      {isPhaseLoading ? (
        <DocFlowCombiningProgress loadingPercent={loadingPercent} />
      ) : (
        <DocFlowPhaseTable
          TableRow={DocFlowCombiningTableRow}
          disableActions={asyncActionInProccess}
          emptyStateText='DocumentStapling.CombiningTableNoDataKey'
          entity={DOC_FLOW_COMBINING_ENTITY}
          getActions={getCombiningTableItemActions}
          getFilterApi={getFilterApi}
          getMassActions={getCombiningMassActions}
          selectionData={selectionData}
          setItemAction={setItemAction}
          setMassAction={setMassAction}
          tableLoader={tableData}
          tableRowProps={{
            onCombinedDocument: handleCombinedDocument,
          }}
          updateTableConfig={updateTableConfig}
        />
      )}
    </>
  )
}

export default DocFlowCombining
